/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { integrationAccessConnectionsControllerFindAll } from "./integrationAccessConnectionsControllerFindAll";
import { integrationAccessRecordsControllerFindAll } from "./integrationAccessRecordsControllerFindAll";

export function integrationAccessService() {
  return { integrationAccessRecordsControllerFindAll, integrationAccessConnectionsControllerFindAll }
}